import { action as solidAction, query as solidQuery } from '@solidjs/router';
import { apiCache } from './cache.ts';
import type { Action, CachedFunction, Submission } from '@solidjs/router';

// oxlint-disable-next-line typescript/no-explicit-any
export function action<T extends Array<any>, U = void>(
	method: (...args: T) => Promise<U>,
	key: string,
): (onComplete?: (s: Submission<T, U>) => void) => Action<T, U> {
	return (onComplete) => solidAction(method, { name: key, onComplete });
}

export function query<U, T extends (...args: any) => U, R = U extends { data: unknown } ? U['data'] : U>(
	method: T,
	name: string,
): CachedFunction<T> {
	const cacheFn = solidQuery(async (...args: Parameters<T>): Promise<R> => {
		const key = cacheFn.keyFor(...args);

		if (apiCache()?.has(key)) {
			return apiCache()!.get(key)! as R;
		}

		const res = (await method(...args)) as Response;
		const data = (await res.json()) as R;

		if (data) {
			apiCache()?.set(key, data);
		}

		return data;
	}, name);

	return cacheFn as unknown as CachedFunction<T>;
}
